import type {
    AnalyticsButtonInfo,
    AnalyticsEvent,
    AnalyticsEventImpression,
    AnalyticsPageImpression,
    AnalyticsPageInfo,
} from '@beat-venues/common-types';

const createPageInfo = (
    params: Pick<AnalyticsPageInfo, 'queryParams'>
): AnalyticsPageInfo => {
    const pageInfo: AnalyticsPageInfo = {
        domain: window.location.hostname,
        language: document.documentElement.lang,
        path: window.location.pathname,
        platform: navigator.platform,

        referrer: document.referrer,
        url: document.URL,
        userAgent: navigator.userAgent,
        title: document.title,
        queryParams: params,
        timestamp: '',
    };
    return pageInfo;
};

const createButtonInfo = (
    buttonInfo: AnalyticsButtonInfo
): AnalyticsButtonInfo => {
    return buttonInfo;
};

const createPageImpression = (
    pageInfo: AnalyticsPageImpression
): AnalyticsPageImpression => {
    return pageInfo;
};

const createEventImpression = (
    eventInfo: AnalyticsEventImpression
): AnalyticsEventImpression => {
    return eventInfo;
};

const createPageViewEvent = (
    params: Pick<AnalyticsPageInfo, 'queryParams'>
): AnalyticsEvent => {
    const event: AnalyticsEvent = {
        event: 'pageView',
        info: null,
        pageInfo: createPageInfo(params),
    };
    return event;
};

export {
    createButtonInfo,
    createEventImpression,
    createPageImpression,
    createPageViewEvent,
};
